import Component from 'ShopUiBundle/modules/app/component';
import { Breakpoints } from 'ShopUiBundle/modules/breakpoints';
import ViewLoader, { State } from 'ShopUiBundle/components/atoms/view-loader/view-loader';
import { updateDebounced as updateLazyLoading } from 'ShopUiBundle/assets/js/components/lazyload';

function loadIfNotLoaded(loader: ViewLoader | null): boolean {
    const state = loader?.state;
    const shouldLoaded = !(state === State.LOADING || state === State.SUCCESS);

    if (shouldLoaded) {
        loader?.load().then(() => {
            updateLazyLoading();
        });
    }

    return shouldLoaded;
}

export default class ShopHeader extends Component {

    private mobileLoader: ViewLoader | null;
    private desktopLoader: ViewLoader | null;
    private searchButton: HTMLButtonElement | null;
    private headerBottom: HTMLButtonElement | null;

    constructor() {
        super();
        this.mobileLoader = this.queryElement('mobile-navigation-loader');
        this.desktopLoader = this.queryElement('desktop-navigation-loader');
        this.searchButton = this.queryElement('search-button');
        this.headerBottom = this.queryElement('bottom');
        this.onResize = this.onResize.bind(this);
        this.onSearchButtonClick = this.onSearchButtonClick.bind(this);
        this.onPageClick = this.onPageClick.bind(this);
    }

    mountCallback(): void {
        if (Breakpoints.compareBreakpointByName('large') >= 0) {
            loadIfNotLoaded(this.desktopLoader);
        } else {
            loadIfNotLoaded(this.mobileLoader);
        }

        window.addEventListener('resize', this.onResize);
        this.searchButton?.addEventListener('click', this.onSearchButtonClick);
    }

    disconnectedCallback(): void {
        this.removeResizeListener();
    }

    private removeResizeListener() {
        window.removeEventListener('resize', this.onResize);
        this.searchButton?.removeEventListener('click', this.onSearchButtonClick);
    }

    private onResize(): void {
        let didLoad;

        if (Breakpoints.compareBreakpointByName('large') >= 0) {
            didLoad = loadIfNotLoaded(this.desktopLoader);
        } else {
            didLoad = loadIfNotLoaded(this.mobileLoader);
        }

        if (didLoad) {
            this.removeResizeListener();
        }
    }

    private onSearchButtonClick(e: Event): void {
        if (this.headerBottom) {
            if (this.hasModifier('open')) {
                this.hideSearchbar();
            } else {
                this.showSearchbar();
                e.stopPropagation();
            }
        }
    }

    private onPageClick(e: Event): void {
        if (!(e.target as HTMLElement)?.closest('shop-header')) {
            this.hideSearchbar();
        }
    }

    private showSearchbar() {
        this.setModifier('open')
        document.body.addEventListener('click', this.onPageClick);
    }

    private hideSearchbar(): void {
        this.removeModifier('open');
        document.body.removeEventListener('click', this.onPageClick);
    }
}
